import Vue from "vue";
import Vuex from "vuex";
import user from "./module/user";
import renew from "./module/renew";
import orderDetail from "./module/orderDetail";
import padList from "./module/padList";
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";
var ls = new SecureLS({});

Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    user,
    renew,
    orderDetail,
    padList
  },
  plugins: [createPersistedState({
    storage: {
      getItem: (key) => ls.get(key),
      setItem: (key, value) => ls.set(key, value),
      removeItem: (key) => ls.remove(key),
    },
  })]
});



// WEBPACK FOOTER //
// ./src/store/index.js